import styled from 'styled-components';
import media from 'src/styles/Media.styled'; 
import { BASE_TEXT_PX, FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, LARGE_TEXT_PX, PRIMARY_FONT_COLOR, RED_FONT_COLOR, SECONDARY_FONT_COLOR, SMALL_TEXT_PX,
     TITLE_FONT_COLOR, WHITE_FONT_COLOR, X_LARGE_TEXT_PX, X_SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

export const FloatingButtonDiv = styled.div`
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: ${({ isFim }) => (isFim ? '10000002' : '200000')};
`;

export const ReportIssueContainer = styled.div`
    height:  ${({ isMobile, isSuccess}) => (!isMobile ? !isSuccess? '': 'auto' : '')};
    max-height: ${({ isSuccess }) => (!isSuccess ? '90vh' : '')};
    width: 100%;
    padding: 16px;
    overflow-y: ${({ isMobile }) => (isMobile ? '' : 'auto')};
    // overflow-x: hidden;
    box-sizing: border-box;
    
    /* Force scrollbar to always be visible when content overflows */
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    
    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
    
    ${media.mobileDevice`
        max-height: ${({ mbHeight }) => (mbHeight ? mbHeight : '100%')};
        width: 100%;
        padding: 20px;
    `}; 
`;

export const ButtonDiv = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${({ isMobile }) => (isMobile ? '' : '10px')};
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'flex-start'};

    ${media.smalDevice`
        width: 100%; 
    `} 
    ${media.mobileDevice`
        margin-bottom: ${({ marginBottom }) => (marginBottom)};
    `} 
`;

export const StyledDiv = styled.div`
    width: 100px;
    ${media.mobileDevice`
        width: 150px;        
        `}
`;

export const MainContainer = styled.div`
    display: ${({ display }) => (display ? display : 'flex')};
    flex-direction: ${({ flexDirection }) => (flexDirection ? flexDirection : 'column')};
    justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : 'space-between')};
    align-items: ${({ alignItems }) => (alignItems ? alignItems : '')};
    min-height: ${({ minHeight }) => (minHeight ? minHeight : '100%')};
`;

export const MainContainerSecond = styled.div`
    display: flex;
    flex: ${({ flex }) => (flex ? flex : '50%')};
    flex-direction: column;
    position: relative;
    width: 100%;
    padding: ${({ padding }) => (padding ? padding : '5px')};
    box-sizing: ${({ boxSizing }) => (boxSizing ? boxSizing : '')};
    
    ${media.mobileDevice`
        padding: ${({ padding }) => (padding ? padding : '20px 22px')};
    `};
    margin-top: ${({ setMarginTop }) => (setMarginTop ? setMarginTop : '')};
    margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '')};

    // align-items:center;
    ${media.mobileDevice` 
        margin-bottom: ${({ marginBottom }) =>
            marginBottom ? marginBottom : ''};
        flex: ${({ flex }) => (flex ? flex : '50%')};
    `};
`; 

export const TextArea = styled.textarea`
    resize: none;
    width: auto;
    height: ${({ height }) => (height ? height : '120px')};
    // margin-top: 20px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border:  1px solid #b1b1bf;
    border-radius: 0px;
    font-family: ${FONT_FAMILY_REGULAR};
    letter-spacing: -0.11px;
    font-size: ${SMALL_TEXT_PX};
    padding: 10px 0 0 10px;
    // margin-bottom:12px;
    &::-webkit-input-placeholder {
    }
    &:focus {
        outline: none !important;
    }
    ${media.mobileDevice`
        // margin-top:12px;
        height: 120px;
        width: auto;
    `} 
`;

export const UploadImageContainer = styled.div`
    display: flex; 
    align-items: center;  
    text-decoration: underline; 
    opacity: 1;
    font-size: ${SMALL_TEXT_PX}; 
    color: ${TITLE_FONT_COLOR};
    margin: ${({ removeMargin }) => (removeMargin ? 0 : '5px 0px 0px 0px')};
`;

export const Title = styled.div`
    font-size: ${X_LARGE_TEXT_PX};
    font-family: ${FONT_FAMILY_DEMI};
    color: ${PRIMARY_FONT_COLOR}; 
`;

export const CustomText = styled.p`
    font-size: ${({ fontSize }) => (fontSize ? fontSize : BASE_TEXT_PX)};
    font-family: ${({ fontFamily }) => (fontFamily ? fontFamily : FONT_FAMILY_REGULAR)};
    color: ${({ color }) => (color ? color : PRIMARY_FONT_COLOR)};
    margin-bottom: ${({ marginBottom }) => (marginBottom ? marginBottom : '12px')}; 
`;

export const ActionsContainer = styled.div`
    display: flex;
    flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
    justify-content: space-between;
    align-items:  ${({ isMobile }) => (isMobile ? '' : 'flex-start')}; 
`;

export const AttachedImagesContainer = styled.div`
    // margin-top: 16px;
`;

export const AttachedImagesContainer2 = styled.div` 
    display: flex; 
    flex-direction: column;
    gap: 10px;
    margin-top: 8px; 
    margin-bottom: 8px;
`;

export const AttachedImagesContainer3 = styled.div` 
    display: flex;
    align-items: center;
    // gap: 4px;
    margin-bottom: ${({ isLast }) => (isLast ? '0' : '0px')};
`;

export const FileNameDiv = styled.span` 
    display: inline-block;
    flex: 0 1 auto; 
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_DEMI};
    color: ${TITLE_FONT_COLOR};
   // text-decoration: underline;
    cursor: pointer;
    // max-width: 300px;
    word-break: break-word;
    overflow-wrap: break-word;
    line-height: 18px;
`;

export const UploadContainer2 = styled.div` 
    display: inline-flex;
    align-items: center;
    cursor: pointer;
`;

export const AttachImageLabel = styled.label` 
    text-align: start; 
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_DEMI};
    color: ${TITLE_FONT_COLOR};
    cursor: pointer;
`;

export const ErrorLabel = styled.p` 
    font-size: ${X_SMALL_TEXT_PX};
    color: ${RED_FONT_COLOR};
    font-family: ${FONT_FAMILY_REGULAR};
    // word-break: break-all;
    margin-top: 8px;
    margin-bottom: 0px;
`;

export const PreviewContainer = styled.div` 
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 10001;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
`;

export const PreviewTitle = styled.div` 
    font-size: ${LARGE_TEXT_PX};
    color: ${WHITE_FONT_COLOR};
    margin-bottom: 20px;
    text-align: center;
    max-width: 90%;
    word-break: break-word; 
`;

export const PreviewDiv = styled.div`
    width: 90%;
    height: 80vh;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
                       
`;

export const CharactersRemainingText = styled.p` 
    font-size: ${X_SMALL_TEXT_PX};
    color: ${SECONDARY_FONT_COLOR};
    text-align: right;
    margin-bottom: 0px;
    margin-top: 0px;
`;

export const ReportIssueButton = styled.div` 
    position: fixed;
    right: 0;
    bottom: ${({ calculatedBottom }) => `${calculatedBottom}px`};
    z-index: 200000;
    cursor: ${({ isDragging }) => (isDragging ? 'grabbing' : 'grab')};
    transition: ${({ isDragging }) => (isDragging ? 'none' : 'box-shadow 0.2s')};
    width: ${({ isMobile }) => (isMobile ? '20px' : '26px')};
    height: ${({ isMobile }) => (isMobile ? '95px' : '109px')};
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 6px 0 0 6px;
    color: white;
    font-weight: 600;
    writing-mode: vertical-rl;
    text-align: center;
    user-select: none;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15); 
`;

export const ReportIssueButtonText = styled.span` 
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    letter-spacing: 1px;
    transform: rotate(180deg);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: ${({ isMobile }) => (isMobile ? X_SMALL_TEXT_PX: SMALL_TEXT_PX)};
    font-family:  ${FONT_FAMILY_DEMI}, sans-serif;
    line-height: 1;
`;

export const SubmitContainer = styled.div` 
    height:${({ height }) => (height ? height : 'auto')}; 
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    ${media.mobileDevice`
        margin-bottom: ${({ marginBottom }) => (marginBottom  ? marginBottom : '0')};
    `} 
`;